import { useQuery } from 'react-query';
import { buildEndpoint } from '../endpoints';
import { apifetch } from '../robotapi';

export interface GetLinkInvestmentRetirementRequest {
    paymentSingleAmount: number;
    paymentRecurringAmount: number;
    paymentRecurringInterval: string;
    paymentRecurringEndDate: string;
    monthOfPayment: number;
    fundModelTypeId: number;
    investmentEndDate: string;
    riskReduction: boolean;
}

type GetLinkInvestmentRetirementResponse = string;

const getLinkInvestmentRetirementUrl = buildEndpoint(['products', 'investmentretirement', 'links']);

const getLinkInvestmentRetirementApiCall = (body: GetLinkInvestmentRetirementRequest) =>
    apifetch<GetLinkInvestmentRetirementResponse, GetLinkInvestmentRetirementRequest>(getLinkInvestmentRetirementUrl, 'POST')(body);

export const useGetLinkInvestmentRetirement = (body: GetLinkInvestmentRetirementRequest, enabled: boolean) => {
    const query = useQuery<GetLinkInvestmentRetirementResponse>(['investmentretirementlink', body], async () => {
        return getLinkInvestmentRetirementApiCall(body);
    },
        { enabled: enabled }
    );

    return query;
};